module.exports = __webpack_public_path__ + "img/cold-shipping.8655d744.png";